// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a2-0";
export var orangeButton = "_a2-1";